<template>
    <div>
        <div class="container">
            <div class="two-content" style="margin-bottom:60px;">
                <div class="photo-container">
                    <img src="/amm1/asset/images/banner.jpg" alt="">
                </div>
                <div class="title-container">
                    <h4 class="title">Open Policy Meeting dan AMM 2018</h4>
                    <ul class="description">
                        <li> <i class="icon-checklist"></i> <p> Workshop, 27-29 November 2018 </p> </li>
                        <li> <i class="icon-checklist"></i> <p> Open Policy Meeting 2018, 29 November 2018  </p> </li>
                        <li> <i class="icon-checklist"></i> <p> 1<sup>st</sup> IDNIC Annual Member Meeting, 29 November 2018 </p>
                        </li>
                    </ul>
                    <div class="container text-center">
                        <a href="#" class="btn btn-success btn-md"> Daftar Sekarang </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="location">
            <div id="event-location" class="map-container">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15865.167730252599!2d106.8312593!3d-6
                .225186!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x54fd31f2806946cb!2sManhattan+Hotel!5e0!3m2!1sen!2sid
                !4v1541668353598" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
                <div id="map"></div>
            </div>
            <div class="description">
                <h4 class="title">
                    Our Venue
                </h4>
                <div class="location-description">
                    <p>Hotel Manhattan</p>
                    <p>Jakarta Indonesia</p>
                </div>
                <a href="#" class="btn btn-md btn-find-more">Find Out More</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>